import { render, staticRenderFns } from "./contacts-profile.vue?vue&type=template&id=3b4c15e0"
import script from "./contacts-profile.vue?vue&type=script&lang=js"
export * from "./contacts-profile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports